// Module
var code = "<p class=\"regelgeving\"> <a>{{::ctrl.sItem.identifier}}</a> <ws-content-block s-item=\"::item\" s-color=\"::ctrl.sColor\" ng-repeat=\"item in ::ctrl.sItem.children\" ng-if=\"::ctrl.sItem.children\"></ws-content-block> </p> ";
// Exports
module.exports = code;